(() => {
  if (!document.body.classList.contains('mmx-pdp')) return;

  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  const labels = ['Entre sur le terrain', 'Le terrain', 'En action', 'Le design', 'La texture', 'Autre angle'];
  const spec = document.body.getAttribute('data-mmx-spec') || '91,4 × 45,7 cm';

  const kickerFrom = (slide, index) => {
    const alt = ((slide && slide.querySelector('img') && slide.querySelector('img').alt) || '').toLowerCase();
    if (/utilis|ambiance|play/.test(alt)) return 'En action';
    if (/ourlet|détail|detail|texture|surface/.test(alt)) return 'La texture';
    if (/bureau|clavier|desk|setup/.test(alt)) return 'En action';
    if (/trois[- ]quarts|angle|silhouette/.test(alt)) return 'Autre angle';
    return labels[index] || 'Vue';
  };

  const slides = () => [...gallery.querySelectorAll('slideshow-slide.product-media-container')];

  const activeSlide = () => {
    const list = slides();
    return list.find((s) => s.getAttribute('aria-hidden') !== 'true') || list[0] || null;
  };

  const pad = (n) => String(n).padStart(2, '0');

  const hud = document.createElement('div');
  hud.className = 'mmx-hud';
  hud.setAttribute('aria-hidden', 'true');
  hud.innerHTML =
    '<span class="mmx-hud__tag"></span><span class="mmx-hud__count"></span>';
  const frame = document.createElement('span');
  frame.className = 'mmx-hud__frame';

  const kicker = document.createElement('p');
  kicker.className = 'mmx-gal-kicker';
  kicker.setAttribute('aria-live', 'polite');

  const stage = gallery.querySelector('slideshow-component');
  if (stage) {
    stage.style.position = 'relative';
    stage.appendChild(hud);
    stage.appendChild(frame);
    stage.insertAdjacentElement('afterend', kicker);
  } else {
    gallery.appendChild(hud);
    gallery.appendChild(kicker);
  }

  const tagEl = hud.querySelector('.mmx-hud__tag');
  const countEl = hud.querySelector('.mmx-hud__count');

  const sync = () => {
    const list = slides();
    const current = activeSlide();
    const index = Math.max(0, list.indexOf(current));
    const total = Math.max(1, list.length);
    kicker.textContent = kickerFrom(current, index);
    if (tagEl) tagEl.textContent = spec + ' · XXL';
    if (countEl) countEl.textContent = pad(index + 1) + ' / ' + pad(total);
  };

  sync();

  const scroller = gallery.querySelector('slideshow-slides');
  if (scroller && 'MutationObserver' in window) {
    const mo = new MutationObserver(sync);
    mo.observe(scroller, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'aria-selected'] });
    gallery.querySelectorAll('slideshow-controls').forEach((el) => {
      mo.observe(el, { attributes: true, subtree: true, attributeFilter: ['aria-selected'] });
    });
  }

  gallery.querySelectorAll('slideshow-controls button').forEach((btn) => {
    btn.addEventListener('click', () => requestAnimationFrame(sync));
  });

  const resetShift = () => {
    gallery.querySelectorAll('slideshow-slide .product-media__image').forEach((img) => {
      img.style.setProperty('--mmx-px', '0px');
      img.style.setProperty('--mmx-py', '0px');
      img.style.setProperty('--mmx-ps', '1');
    });
    gallery.style.setProperty('--mmx-ax', '0px');
    gallery.style.setProperty('--mmx-ay', '0px');
    gallery.querySelectorAll('.is-mmx-live').forEach((el) => el.classList.remove('is-mmx-live'));
  };

  if (!reduce.matches && fine.matches) {
    const host = gallery.querySelector('slideshow-slides') || gallery;
    let ticking = false;
    let px = 0;
    let py = 0;

    host.addEventListener(
      'pointermove',
      (event) => {
        if (event.pointerType && event.pointerType !== 'mouse') return;
        if (document.querySelector('.dialog-zoomed-gallery__dialog[open]')) return;
        px = event.clientX;
        py = event.clientY;
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const slide = activeSlide();
          if (!slide) return;
          const img = slide.querySelector('.product-media__image');
          if (!img) return;
          const box = slide.getBoundingClientRect();
          if (box.width < 8 || box.height < 8) return;
          const rx = Math.max(-1, Math.min(1, ((px - box.left) / box.width - 0.5) * 2));
          const ry = Math.max(-1, Math.min(1, ((py - box.top) / box.height - 0.5) * 2));
          gallery.style.setProperty('--mmx-ax', (-rx * 10).toFixed(2) + 'px');
          gallery.style.setProperty('--mmx-ay', (-ry * 6).toFixed(2) + 'px');
          img.style.setProperty('--mmx-px', (-rx * 14).toFixed(2) + 'px');
          img.style.setProperty('--mmx-py', (-ry * 10).toFixed(2) + 'px');
          img.style.setProperty('--mmx-ps', '1.02');
          slide.classList.add('is-mmx-live');
        });
      },
      { passive: true }
    );

    host.addEventListener('pointerleave', resetShift);
  } else if (!reduce.matches) {
    gallery.addEventListener(
      'touchstart',
      (event) => {
        const slide = event.target.closest('slideshow-slide');
        if (slide) slide.classList.add('is-mmx-touch');
      },
      { passive: true }
    );
    const clearTouch = () => {
      gallery.querySelectorAll('.is-mmx-touch').forEach((el) => el.classList.remove('is-mmx-touch'));
    };
    gallery.addEventListener('touchend', clearTouch, { passive: true });
    gallery.addEventListener('touchcancel', clearTouch, { passive: true });
  }
})();
